<template>
  <div class="appointment-container mb-20 p-25">
    <div class="row">
      <div class="col-lg-3"></div>
      <div class="col-lg-4 text-right">
        <div class="weekly-navigation font-weight-bold">
          <div v-if="!isLoadingAppointment">
            <span @click="previousWeekList" class="fa fa-chevron-left arrowColor"></span>

            <span class="week-date ml-12 mr-12 text-uppercase">{{ weekDateString }}</span>

            <span @click="nextWeekList" class="fa fa-chevron-right arrowColor"></span>
          </div>
          <div v-if="isLoadingAppointment">Loading...</div>
        </div>
      </div>
      <div class="col-lg-5 text-right btnGroupAlignment mb-10">
        <router-link v-if="isVisitsConfiguredInStudy && !canSiteDataLockAccess && !canInterviewerAccess && !user.readOnly" tag="button" class="btn btn-outline-primary btn-sm ml-auto availability-btn" :to="{ name: `${isTestPortal ? TEST_PORTAL_SUFFIX_CONST : ''}study-participant-availability` }">Availability</router-link>
        <button v-if="!canSiteDataLockAccess && !user.readOnly" type="button" class="btn btn-health new-video-call-btn ml-12" @click="showParticipantModal" :disabled="getVideoCallStatus">
          New Telehealth Call
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12">
        <div class="appointments">
          <div class="list-header pt-5 pb-5">
            <div class="row">
              <div class="col-lg-6">
                <span class="week-date fw-25">Last updated less than {{ lastUpdateTime }}</span>
              </div>
              <div class="col-lg-6 text-right">
                <span class="mr-20"><img v-bind:src="'/static/img/telehealth/Telehealth_status_complete.png'" /> Complete</span>
                <span class="mr-20"
                  ><img v-bind:src="'/static/img/telehealth/Telehealth_status_canceled.png'" />
                  Canceled or Rescheduled
                </span>
                <span
                  ><img v-bind:src="'/static/img/telehealth/Telehealth_status_missed.png'" />
                  Missed
                </span>
              </div>
            </div>
          </div>
          <div class="appointment-lists" v-if="appointmentList.length > 0">
            <fieldset v-for="(appointments, index) in appointmentList" :key="index">
              <span :id="appointments.date.replace(/ /g, '')" class="date-legend">{{ checkIsToday(appointments.date) }}{{ appointments.date }}</span>
              <div class="media appointment-details" :class="[appointment.status.toLowerCase(), appointment.type, `${appointment.visitType.toLowerCase()}-visit`]" v-for="(appointment, aIndex) in appointments.appointments" :key="aIndex" :id="appointment.id">
                <span class="align-self-center visit-type-icon" :class="appointment.status == 'NotStarted' && appointment.type == 'scheduled' && hasCallTimePassed(appointment) ? 'call-time-passed' : ''"></span>
                <span class="align-self-center status-icon mr-4" :class="getVideoCallStatus && getInProgressCallId() == appointment.id ? 'call-in-progress' : ''"></span>
                <div class="media-body">
                  <div>
                    <strong>{{ showVisitTypeDesc(appointment.visitType) }}</strong>
                  </div>
                  <div v-if="appointment.participantName">Participant name: {{ appointment.participantName }}</div>
                  <div v-if="isEligibleForPPR">
                    THREAD ID:
                    <router-link
                      :to="{
                        name: `${isTestPortal ? TEST_PORTAL_SUFFIX_CONST : ''}participant-profile`,
                        params: { participantId: appointment.threadID }
                      }"
                      >{{ appointment.threadID }}</router-link
                    >
                  </div>
                  <div v-if="!isEligibleForPPR">
                    THREAD ID:
                    <router-link
                      :to="{
                        name: `${isTestPortal ? TEST_PORTAL_SUFFIX_CONST : ''}study-participant-details`,
                        params: { participantId: appointment.threadID }
                      }"
                      >{{ appointment.threadID }}</router-link
                    >
                  </div>
                  <div>
                    Participant ID:
                    <span class="user-definied-pID" v-if="!appointment.participantId">None</span>
                    <span class="user-definied-pID" else>{{ appointment.participantId }}</span>
                  </div>
                  <div class="appointment-name">
                    Appointment name:
                    <span v-if="appointment.visitType.toLowerCase() === 'homevisit' || appointment.visitType.toLowerCase() === 'phonecall' || appointment.configFor === 'site'" class="visitNameText" @click="showPhoneVisitDetails(appointment)">{{ appointment.name }}</span>
                    <span v-else>{{ appointment.name == "Unscheduled" ? "On Demand" : appointment.name }}</span>
                  </div>
                  <div v-if="appointment.isRescheduled" class="appointment-name">
                    Rescheduled: Yes
                  </div>
                  <div v-if="!getVideoCallStatus && appointment.visitType.toLowerCase() == 'telehealth' && ((appointment.type == 'scheduled' && (appointment.status == 'NotStarted' || appointment.status == 'InProgress') && showJoinCallBtn(appointment)) || (appointment.type == 'unscheduled' && (appointment.status == 'NotStarted' || appointment.status == 'InProgress')))" class="mt-5">
                    <button @click="initateVideoCall(appointment)" type="button" class="btn btn-success join-call">
                      Join call
                    </button>
                  </div>
                </div>
                <span v-if="canUpdateAppointmentStatus() && (appointment.visitType.toLowerCase() == 'in-person' || appointment.visitType.toLowerCase() == 'homevisit' || appointment.visitType.toLowerCase() == 'phonecall')" class="inperson-status-dropdown align-self-center mr-20">
                  <select :disabled="user.readOnly === true || (appointment.status === 'Cancelled' && appointment.configFor === 'site')" class="form-control" v-model="appointment.status" @change="updateAppointmentStatus(appointment.id, appointment.status)">
                    <option value="NotStarted" disabled>Scheduled</option>
                    <option value="Cancelled" disabled>Cancelled</option>
                    <option value="Complete">Complete</option>
                    <option value="Missed">Missed</option>
                  </select>
                </span>
                <span class="align-self-center ml-12 time">{{ appointment.time }}</span>
              </div>
            </fieldset>
          </div>
          <div v-else class="text-muted align-self-center p-20 text-center response-msg">
            {{ responseListMsg }}
          </div>
        </div>
      </div>
    </div>

    <participantsModal ref="participantsModal"></participantsModal>
    <b-modal ref="VisitsListsHomePhonecallDataViewModal" id="visits-lists-home-phonecall-data-view-modal" no-close-on-backdrop hide-footer hide-header body-class="modal-body-custom pt-0">
      <div class="clearfix"></div>
      <div class="activityNameLayout">
        <b
          ><p class="fs-16 pl-10 pr-10">{{ visitTypeDetails.name }}<br /></p
        ></b>
      </div>
      <div class="clearfix"></div>
      <div>
        <b-row class="rowDiv pt-10 pb-10">
          <b-col cols="4">
            <div class="subHeading pb-5">Participant ID</div>
            <div style="word-break:break-all;">
              <Span v-if="visitTypeDetails.participantId">{{ visitTypeDetails.participantId }}</Span>
              <Span v-else>NA</Span>
            </div>
          </b-col>
          <b-col cols="8">
            <div class="subHeading pb-5">THREAD ID</div>
            <div>{{ visitTypeDetails.threadId }}</div>
          </b-col>
        </b-row>
      </div>
      <div v-if="visitTypeDetails.visitType === 'homevisit'">
        <div class="mt-20">
          <span class="evaluateAddressField">Visit Address </span>
        </div>
        <div class="w-200">
          <span class="evaluateModalPhnoField">
            {{ showVisitAddress(visitTypeDetails.details) }}
          </span>
        </div>
      </div>
      <div v-if="visitTypeDetails.visitType === 'phonecall'">
        <div class="mt-20">
          <span class="evaluateAddressField">Phone Number</span>
        </div>
        <div class="w-200">
          <span class="evaluateModalPhnoField">
            <span v-if="visitTypeDetails.details.countryCode">{{ visitTypeDetails.details.countryCode }}</span>
            <span v-if="visitTypeDetails.details.phoneNumber"> {{ visitTypeDetails.details.phoneNumber }}</span>
          </span>
        </div>
      </div>
      <div class="mt-10" style="float:right;">
        <div style="display:flex;">
          <span class="cancelText mr-20 mt-5" @click="closeScreen()">Cancel</span>
          <button v-if="appointmentDetails.configFor === 'site'" @click="editVisit()" class="btn btn-primary" :disabled="editVisitBtnDisabled">
            <span class="fs-13" @click="editVisit()">Edit Visit</span>
          </button>
        </div>
      </div>
    </b-modal>
    <ScheduleVisitSiteTeam
      v-if="showScheduleVisit"
      modalType="postScheduleVisit"
      :mapVisitsData="mapVisitsData"
      :participantInfo="participantInfo"
      :visitConfiguredDetails="visitConfiguredDetails"
      :appointmentDetails="appointmentDetails"
      :piDetails="piDetails"
      :studyId="studyId"
      :siteTeamSelectedTaskDetails="siteTeamSelectedTaskDetails"
      :siteDetailsInfo="siteDetailsInfo"
      @scheduledVisitData="getConfiguredVisitData"
      @cancelEvent="cancelModal()"
      @cancelVisitEvent="cancelVisitDataEvent"
    />
  </div>
</template>
<script>
import _ from "lodash";
import moment from "moment";
import nprogress from "nprogress";
import toastr from "toastr";
import { AclRule } from "vue-acl";
import { mapGetters } from "vuex";
import { PI, SUB_PI, STUDY_COORDINATOR, SITEDATALOCK, INTERVIEWER, HOME_HEALTH } from "@/constants/authRoles";
import participantsModal from "./participants-modal";
import ScheduleVisitSiteTeam from "../participants/telehealth/schedule-visit-siteteam.vue";
import { TEST_PORTAL_SUFFIX } from "@/constants/config";

export default {
  name: "tele-health-appointments",
  components: { participantsModal, ScheduleVisitSiteTeam },
  data() {
    return {
      studyId: this.$route.params.studyId,
      appointmentList: [],
      searchTerm: "",
      lastUpdated: moment(),
      lastUpdateTime: "just now",
      lastUpdatedInterval: null,
      appointmentListRefreshInterval: null,
      responseListMsg: "Loading...",
      weekStartDate: moment()
        .utc()
        .startOf("week"),
      WeekEndDate: moment()
        .utc()
        .endOf("week"),
      typing: false,
      isLoadingAppointment: false,
      isCurrentWeek: true,
      appointmentListResponse: null,
      isEligibleForPPR: true,
      visitTypeDetails: {},
      showScheduleVisit: false,
      siteTeamSelectedTaskDetails: {},
      mapVisitsData: {},
      participantInfo: {},
      piDetails: {},
      appointmentDetails: {},
      editVisitBtnDisabled: false,
      visitConfiguredDetails: {},
      siteDetailsInfo: {},
      isVisitsConfiguredInStudy: null,
      TEST_PORTAL_SUFFIX_CONST: TEST_PORTAL_SUFFIX
    };
  },
  watch: {
    getVideoCallStatus(isCallInProgress) {
      const self = this;
      if (isCallInProgress) {
        if (self.isCurrentWeek) {
        } else {
          self.displayCurrentWeek();
        }
      }
    }
  },
  created() {
    this.calculateLastUpdated();
    this.isVisitConfiguredInStudy();
    window.setTimeout(() => {
      this.scrollToDate();
    }, 2000);
  },
  mounted() {
    //Load all the appointments from backend
    this.getAppointments();
    this.getToggledFeatures();

    //Look for the publisher/PI event has started call and reload the appointments
    this.$root.$on("publisherStreamStarted", () => {
      this.getAppointments();
    });
    this.$root.$on("scheduledVideoCallingInitiated", data => {
      this.startVideoCall(data);
    });

    //Look for the end call event and reload the appointments
    const self = this;
    this.$root.$on("videoCallEnded", () => {
      setTimeout(() => {
        self.getAppointments();
      }, 100);
    });

    //Reload appointments every 90 seconds
    this.appointmentListRefreshInterval = window.setInterval(() => {
      this.getAppointments();
    }, 90000);
  },
  computed: {
    ...mapGetters(["user", "getVideoCallStatus"]),
    weekDateString() {
      const wsd = this.weekStartDate.format("DD MMM");
      const wsy = this.weekStartDate.format("YYYY");
      const wed = this.WeekEndDate.format("DD MMM");
      const wy = this.WeekEndDate.format("YYYY");

      return `${wsd} ${wsy} - ${wed} ${wy}`;
    },
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    canSubPiAccess() {
      this.$acl.change(`${SUB_PI}`);
      return this.$acl.check("userAccess");
    },
    canScAccess() {
      this.$acl.change(`${STUDY_COORDINATOR}`);
      return this.$acl.check("userAccess");
    },
    canSiteDataLockAccess() {
      this.$acl.change(`${SITEDATALOCK}`);
      return this.$acl.check("userAccess");
    },
    canInterviewerAccess() {
      this.$acl.change(`${INTERVIEWER}`);
      return this.$acl.check("userAccess");
    },
    canHomeHealthAccess() {
      this.$acl.change(`${HOME_HEALTH}`);
      return this.$acl.check("userAccess");
    },
    isTestPortal() {
      return (this.$route.name || this.$route.currentRoute.name || "").includes(TEST_PORTAL_SUFFIX);
    }
  },
  beforeDestroy() {
    clearInterval(this.lastUpdatedInterval);
    clearInterval(this.appointmentListRefreshInterval);
  },
  methods: {
    getToggledFeatures() {
      this.$api.getToggleFeaturesFact(this.studyId).then(
        response => {
          const toggleFeatures = response.body.studyFeatures;
          toggleFeatures.forEach(feature => {
            if (feature.featureKey === "OLDPROFILEVIEW") {
              this.isEligibleForPPR = !feature.enabled;
            }
          });
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting features.");
        }
      );
    },
    calculateLastUpdated() {
      this.lastUpdatedInterval = setInterval(() => {
        const currentTime = moment().utc();
        const timeDiffInSec = currentTime.diff(this.lastUpdated, "seconds");
        if (timeDiffInSec <= 0) {
          this.lastUpdateTime = "just now";
        } else if (timeDiffInSec >= 60) {
          this.lastUpdateTime = "a minute ago";
        } else {
          this.lastUpdateTime = timeDiffInSec + " sec ago";
        }
      }, 3000);
    },
    showJoinCallBtn: function(appnt) {
      const now = moment();
      const apdate = moment(appnt.startTime);
      const appointmentEndtime = moment(appnt.endTime);
      //Do not show join call for past dates,compare it with call end duration
      if (appointmentEndtime.isBefore(now)) {
        return false;
      }

      const td = apdate.diff(now, "minutes", true);

      return td <= 5;
    },
    getAppointments() {
      const self = this;

      //let siteId = this.user.siteIds ? this.user.siteIds[0] : null;
      const pId = this.user.id;

      const st = this.weekStartDate.format("DD MMM YYYY hh:mm A");
      const ed = this.WeekEndDate.format("DD MMM YYYY hh:mm A");

      const weekFrom = moment(st, "DD MMM YYYY hh:mm A").utc();
      const weekTo = moment(ed, "DD MMM YYYY hh:mm A").utc();
      let siteId = "";
      if (this.user.userRole == "Interviewer") {
        siteId = localStorage.getItem("selectedSite").toString();
      } else {
        siteId = this.user.siteIds ? this.user.siteIds[0] : null;
      }

      //For getting all the appointments
      let isUserRole = false;
      if (this.user.userRole == "Interviewer") {
        isUserRole = true;
      }

      this.$api
        .getTelehealthAppointmentList({
          siteId: siteId,
          pId: pId,
          startDate: weekFrom.valueOf(),
          endDate: weekTo.valueOf(),
          searchTerm: this.searchTerm,
          studyId: this.studyId,
          isUserRole: isUserRole
        })
        .then(
          response => {
            self.isLoadingAppointment = false;
            self.appointmentList = [];
            self.lastUpdated = moment();
            const responseObj = response.body;
            if (responseObj.length == 0) {
              self.responseListMsg = "No appointments.";
              return;
            }

            self.appointmentListResponse = responseObj;
            _.forEach(responseObj, function(element) {
              let appointmentDateObj = null;
              if (element.type == "Scheduled") {
                appointmentDateObj = moment(element.startTime);
              } else if (element.type == "Unscheduled") {
                appointmentDateObj = moment(element.appointmentDate);
              }
              const appointmentDatestr = appointmentDateObj.format("DD MMM YYYY");
              const threadIDStr = element.participantId;
              const participantIDStr = element.userDefineParticipantId;
              const appointmentNameStr = element.visitName ? element.visitName : element.type;

              let isRescheduledAppointment = false;
              const appointmentTimeStr = appointmentDateObj.format("hh:mm A");
              let statusStr = element.status;
              statusStr = statusStr.replace(/ /g, "");
              if (statusStr == "NotStarted" && element.visitType.toLowerCase() == "telehealth") {
                // So the list refresh every 90 sec and if the appointment duration(End Time) has passed and the list is not refreshed with latest status then show the missed status from Web UI
                const appointmentEndTimeObj = moment(element.endTime);
                statusStr = appointmentEndTimeObj.isBefore(moment()) ? "Missed" : statusStr;
              } else if (statusStr.toLowerCase() == "reschedule") {
                isRescheduledAppointment = true;
                statusStr = "Cancelled";
              } else if (statusStr.toLowerCase() == "sitecancelled") {
                statusStr = "Cancelled";
              }

              const aObjIndex = _.findIndex(self.appointmentList, function(o) {
                return o.date == appointmentDatestr;
              });
              let participantAppointmentContact = {};
              if (element.participantAppointmentContact) {
                participantAppointmentContact = element.participantAppointmentContact;
              }
              const configFor = element.configFor ? element.configFor : "participant";
              const appointmentDetailObject = {
                threadID: threadIDStr,
                participantId: participantIDStr,
                name: appointmentNameStr,
                time: appointmentTimeStr,
                status: statusStr,
                type: element.type.toLowerCase(),
                appDateTime: element.appointmentDate,
                id: element.id,
                visitId: element.visitId,
                startTime: element.startTime,
                endTime: element.endTime,
                isRescheduled: isRescheduledAppointment,
                visitType: element.visitType,
                participantAppointmentContact: participantAppointmentContact,
                configFor: configFor
              };

              if (aObjIndex != -1) {
                self.appointmentList[aObjIndex].appointments.push(appointmentDetailObject);
              } else {
                self.appointmentList.push({
                  date: appointmentDatestr,
                  appointments: [appointmentDetailObject]
                });
              }
            });

            self.$nextTick(function() {
              // DOM updated
              self.scrollToAppointment();
            });
          },
          error => {
            self.isLoadingAppointment = false;
            const errMsg = "Error while getting the appointment list!";
            self.responseListMsg = errMsg;
            toastr.error(error.body && error.body.message ? error.body.message : errMsg);
          }
        );
    },
    showParticipantModal() {
      this.$refs.participantsModal.show();
    },
    getParticipantID(threadID, pIndex, cIndex) {
      this.$api.getParticipantsListFact(this.studyId, 1, 1, threadID, "", "", "", "").then(
        response => {
          if (response.body.totalParticipants > 0) {
            if (!response.body.participants[0].userDefinedParticipantId) {
              this.appointmentList[pIndex].appointments[cIndex].participantId = "Not Exists!";
            } else {
              this.appointmentList[pIndex].appointments[cIndex].participantId = response.body.participants[0].userDefinedParticipantId;
            }
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting participant ID.");
        }
      );
    },
    displayCurrentWeek() {
      this.weekStartDate = moment()
        .utc()
        .startOf("week");
      this.WeekEndDate = moment()
        .utc()
        .endOf("week");
      //Load the Appointments
      this.isCurrentWeek = true;
      this.getAppointments();
    },
    previousWeekList() {
      this.isCurrentWeek = false;
      this.isLoadingAppointment = true;

      const pw = this.weekStartDate.subtract(1, "days");

      this.weekStartDate = moment(pw)
        .utc()
        .startOf("week");
      this.WeekEndDate = moment(pw)
        .utc()
        .endOf("week");

      //Load the appointments
      this.getAppointments();
    },
    nextWeekList() {
      this.isCurrentWeek = false;
      this.isLoadingAppointment = true;

      const nw = this.WeekEndDate.add(1, "days");

      this.weekStartDate = moment(nw)
        .utc()
        .startOf("week");
      this.WeekEndDate = moment(nw)
        .utc()
        .endOf("week");

      //Load the appointments
      this.getAppointments();
    },
    startVideoCall(appointmentObject) {
      appointmentObject.studyId = this.studyId;
      this.$api.getParticipantDataFactV2(this.studyId, appointmentObject.threadID).then(
        response => {
          appointmentObject.countryId = response.body.countryId;
          this.$root.$emit("videoCallingInitiated", appointmentObject);
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting participant.");
        }
      );
    },
    scrollToDate() {
      //CODE TO SCROLL TODAY
      const todaysDate = moment().format("DD MMM YYYY");
      const todayIndex = _.findIndex(this.appointmentList, function(o) {
        return o.date == todaysDate;
      });
      if (todayIndex != -1) {
        const t = todaysDate.replace(/ /g, "");

        const element = document.getElementById(t);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            inline: "nearest"
          });
        }
      }
    },
    scrollToAppointment() {
      if (this.isCurrentWeek) {
        const ccId = window.localStorage.getItem("thread-currentCallId");
        if (ccId) {
          const element = document.getElementById(ccId);
          if (element) {
            element.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
              inline: "nearest"
            });

            //set the Appointment id of the call being in progress in local storage
            localStorage.setItem("thread-inProgressCallId", ccId);

            localStorage.removeItem("thread-currentCallId");
          }
        }
      }
    },
    checkIsToday(date) {
      const todaysDate = moment().format("DD MMM YYYY");
      return moment(date).isSame(todaysDate) ? "Today " : "";
    },
    getInProgressCallId() {
      return localStorage.getItem("thread-inProgressCallId");
    },
    hasCallTimePassed(appnt) {
      const now = moment();
      const appointmentEndtime = moment(appnt.endTime);
      //Do not show join call for past dates,compare it with call end duration
      if (appointmentEndtime.isBefore(now)) {
        return true;
      } else {
        return false;
      }
    },
    updateAppointmentStatus(appointmentId, status) {
      let appointmentObj = _.filter(this.appointmentListResponse, ["id", appointmentId]);
      appointmentObj = appointmentObj[0];
      appointmentObj.status = status;
      this.$api.updateTelehealthAppointmentStatus(appointmentObj).then(
        () => {},
        error => {
          toastr.error(error.body && error.body.message ? error.body.message : "Error occurred while updating the status.");
        }
      );
    },
    initateVideoCall(appointmentDetailObject) {
      this.isCallBtnDisabled = true;
      let countryId = "";
      this.$api.getParticipantDataFactV2(this.studyId, appointmentDetailObject.threadID).then(
        response => {
          countryId = response.body.countryId;
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting participant.");
        }
      );
      //Emit an event to show/start the video call component
      this.$root.$emit("videoCallStarted", {
        participantId: appointmentDetailObject.participantId,
        countryId: countryId,
        studyId: this.studyId,
        deviceRegistrationStatus: true,
        appointmentType: appointmentDetailObject.type,
        appointmentObject: appointmentDetailObject
      });
    },
    canUpdateAppointmentStatus() {
      return this.canPiAccess || this.canSubPiAccess || this.canScAccess || this.canInterviewerAccess;
    },
    showPhoneVisitDetails(record) {
      this.siteTeamSelectedTaskDetails = record;
      this.visitTypeDetails = {
        visitType: record.visitType.toLowerCase(),
        threadId: record.threadID,
        participantId: record.participantId,
        name: record.name,
        details: record.participantAppointmentContact
      };
      const getAppointmentDetails = this.appointmentListResponse.filter(data => data.id === this.siteTeamSelectedTaskDetails.id);
      this.appointmentDetails = getAppointmentDetails[0];
      this.siteTeamSelectedTaskDetails.taskId = this.appointmentDetails.visitId;
      this.siteTeamSelectedTaskDetails.taskInstanceId = this.appointmentDetails.taskInstanceUUID;
      this.editVisitBtnDisabled = false;
      const getCurrentStatus = record.status.toLowerCase();
      if (getCurrentStatus === "cancelled" || getCurrentStatus === "complete" || getCurrentStatus === "missed" || record.isRescheduled || this.appointmentDetails.startTime < new Date().getTime()) {
        this.editVisitBtnDisabled = true;
      }
      this.getParticipantInfoDetails(this.$route.params.studyId, record.threadID, getAppointmentDetails[0]);
      if (record.visitType === "Phonecall" || record.visitType === "Homevisit") {
        this.$api.getContactDetailsFact(record.id, record.threadID).then(response => {
          if (response.body) {
            this.visitTypeDetails.details = response.body;
            this.appointmentDetails.participantAppointmentContact = response.body;
            const checkCountryCodeplus = this.visitTypeDetails.details.countryCode.toString();
            if (checkCountryCodeplus.includes("+") === false) {
              this.visitTypeDetails.details.countryCode = `+${this.visitTypeDetails.details.countryCode}`;
            }
            this.$refs.VisitsListsHomePhonecallDataViewModal.show();
          }
        });
      } else {
        this.$refs.VisitsListsHomePhonecallDataViewModal.show();
      }
    },
    showVisitTypeDesc(visitType) {
      if (visitType === "Telehealth") {
        return "Video Call";
      } else if (visitType === "In-person") {
        return "Office Visit";
      } else if (visitType === "Homevisit") {
        return "Home Visit";
      } else if (visitType === "Phonecall") {
        return "Phone Call";
      } else {
        return visitType;
      }
    },
    closeScreen() {
      this.$refs.VisitsListsHomePhonecallDataViewModal.hide();
    },
    editVisit() {
      if (!this.editVisitBtnDisabled && (this.canPiAccess || this.user.userRole === "SubPi" || this.user.userRole === "StudyCoordinator" || this.user.userRole === "HomeHealth")) {
        this.getVisitConfigDetails(this.$route.params.studyId, this.siteTeamSelectedTaskDetails);
      }
    },
    getConfiguredVisitData(data) {
      if (this.checkforRescheduleFlag(data)) {
        this.$api.reScheduleAppointmentParticipantFact(this.siteTeamSelectedTaskDetails.id, data).then(
          response => {
            if (response.body) {
              this.$toastr.success("Visit rescheduled successfully");
              this.showScheduleVisit = false;
              this.getAppointments();
            }
          },
          err => {
            this.showScheduleVisit = false;
            this.$toastr.error(err.body.message);
          }
        );
      } else {
        const updateObj = {
          address: data.participantAppointmentContact ? data.participantAppointmentContact.address : "",
          city: data.participantAppointmentContact ? data.participantAppointmentContact.city : "",
          state: data.participantAppointmentContact ? data.participantAppointmentContact.state : "",
          country: data.participantAppointmentContact ? data.participantAppointmentContact.country : "",
          zipcode: data.participantAppointmentContact ? data.participantAppointmentContact.zipcode : "",
          countryCode: data.participantAppointmentContact ? data.participantAppointmentContact.countryCode : "",
          phoneNumber: data.participantAppointmentContact ? data.participantAppointmentContact.phoneNumber : "",
          smsCountryIsoName: data.participantAppointmentContact ? data.participantAppointmentContact.smsCountryIsoName : "",
          visitNote: data.visitNote
        };
        this.$api.updateVisitAppointmentFact(this.$route.params.studyId, this.participantInfo.siteId, this.siteTeamSelectedTaskDetails.id, this.siteTeamSelectedTaskDetails.threadID, updateObj).then(
          response => {
            if (response.body) {
              this.$toastr.success("Visit Appointment updated successfully");
              this.showScheduleVisit = false;
            }
          },
          err => {
            this.showScheduleVisit = false;
            this.$toastr.error(err.body.message);
          }
        );
      }
    },
    cancelModal() {
      this.showScheduleVisit = false;
    },
    showVisitAddress(details) {
      let formString = "";
      if (details.address != "") {
        formString = details.address;
      }
      if (details.city != "") {
        formString = formString + ", " + details.city;
      }
      if (details.state != "") {
        formString = formString + ", " + details.state;
      }
      if (details.country != "") {
        formString = formString + ", " + details.country;
      }
      if (details.zipcode != "") {
        formString = formString + ", " + details.zipcode;
      }
      return formString;
    },
    getVisitConfigDetails(studyId, record) {
      this.$api.getVisitDetail(studyId, record.visitId).then(
        response => {
          const getVisitTypes = response.body.telehealthVisitDTO.visitType;
          const visitSplitData = getVisitTypes.split("|");
          const visitsDataObject = [];
          for (let i = 0; i < visitSplitData.length; i++) {
            if (visitSplitData[i] === "Telehealth") {
              visitsDataObject.push({
                name: "Video Call",
                logoUrl: "static/img/telehealth/video-call-icon.svg",
                selected: false
              });
            } else if (visitSplitData[i] === "In-person") {
              visitsDataObject.push({
                name: "Office Visit",
                logoUrl: "static/img/telehealth/office-visit-icon.svg",
                selected: false
              });
            } else if (visitSplitData[i] === "Homevisit") {
              visitsDataObject.push({
                name: "Home Visit",
                logoUrl: "static/img/telehealth/home-visit-icon.svg",
                selected: false
              });
            } else if (visitSplitData[i] === "Phonecall") {
              visitsDataObject.push({
                name: "Phone Call",
                selected: false,
                logoUrl: "static/img/telehealth/phone-call-icon.svg"
              });
            }
          }
          this.mapVisitsData.scheduleVisitType = visitsDataObject;
          this.visitConfiguredDetails = response.body;
          this.callVisitDetails(record);
        },
        error => {
          this.$toastr.error(error.body ? error.body.message : "Error while fetching telehealth visits");
          nprogress.done();
        }
      );
    },
    getParticipantInfoDetails(studyId, threadID, appointmentDetails) {
      this.$api.getParticipantDataFactV2(studyId, threadID).then(
        response => {
          this.participantInfo = response.body;
          this.getPIInfoDetails(studyId, this.participantInfo.siteId);
          this.getStudyDetails();
          this.$api.getVisitAppoitmentFact(studyId, this.participantInfo.siteId, appointmentDetails.id, appointmentDetails.participantId).then(
            response => {
              if (response.body) {
                this.appointmentDetails = response.body;
                if (this.appointmentDetails.status.toLowerCase().trim() === "sitecancelled") {
                  this.editVisitBtnDisabled = true;
                }
              }
            },
            err => {
              this.$toastr.error(err.body.message);
            }
          );
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting participant.");
        }
      );
    },
    async getPIInfoDetails(studyId, siteId) {
      const getDataList = await this.$api.getPI_ID(studyId, siteId);
      this.piDetails = getDataList.body.find(data => data.id === this.user.id);
    },
    async callVisitDetails(record) {
      const getAppointmentDetails = this.appointmentListResponse.filter(data => data.id === record.id);
      const getSlotsData = await this.$api.getTelehealthVisitSlotsFact(this.$route.params.studyId, this.participantInfo.siteId, record.threadID, getAppointmentDetails[0].visitId, getAppointmentDetails[0].taskInstanceUUID, this.getLocalOffset(), this.getLocalTimeZone());
      this.processSlotsDateTime(getSlotsData.body);
    },
    processSlotsDateTime(slotsList) {
      const getDates = Object.keys(slotsList);
      const getTimeValues = [];
      this.mapVisitsData.dateTotalValues = [];
      for (let i = 0; i < getDates.length; i++) {
        const dateObject = {
          selected: false,
          dateValue: parseInt(getDates[i]),
          index: i
        };
        this.mapVisitsData.dateTotalValues.push(dateObject);
        const timeValuesObject = {
          [getDates[i]]: slotsList[getDates[i]]
        };
        getTimeValues.push(timeValuesObject);
      }
      this.mapVisitsData.timeTotalValues = [];
      for (let j = 0; j < getDates.length; j++) {
        this.formatTimeValues(getDates[j], getTimeValues);
      }
      this.prefillAppointmentData();
    },
    formatTimeValues(dateValue, getTimeValues) {
      const getfilteredTimeValues = getTimeValues.filter(data => {
        return data[dateValue];
      });
      const timesValues = Object.keys(getfilteredTimeValues[0][dateValue]);
      for (let j = 0; j < timesValues.length; j++) {
        const obj = getfilteredTimeValues[0][dateValue][timesValues[j]];
        obj.selected = false;
        obj.dateValue = getfilteredTimeValues[0][dateValue][timesValues[j]].slotStartTime;
        obj.currentDate = parseInt(dateValue);
        this.mapVisitsData.timeTotalValues.push(obj);
      }
    },
    getLocalOffset() {
      const offset = new Date().getTimezoneOffset();
      const o = Math.abs(offset);
      return (offset < 0 ? "+" : "-") + ("00" + Math.floor(o / 60)).slice(-2) + ":" + ("00" + (o % 60)).slice(-2);
    },
    prefillAppointmentData() {
      const getAppointmentDetails = this.appointmentListResponse.filter(data => data.id === this.siteTeamSelectedTaskDetails.id);
      this.$api.getVisitAppoitmentFact(this.$route.params.studyId, this.participantInfo.siteId, getAppointmentDetails[0].id, getAppointmentDetails[0].participantId).then(
        response => {
          if (response.body) {
            this.appointmentDetails = response.body;
            if (this.appointmentDetails.status.toLowerCase().trim() === "sitecancelled") {
              this.editVisitBtnDisabled = true;
            }
          }
        },
        err => {
          this.$toastr.error(err.body.message);
        }
      );
      let getVisitType = getAppointmentDetails[0].visitType;
      switch (getVisitType) {
        case "Homevisit":
          getVisitType = "Home Visit";
          break;
        case "Telehealth":
          getVisitType = "Video Call";
          break;
        case "In-person":
          getVisitType = "Office Visit";
          break;
        case "Phonecall":
          getVisitType = "Phone Call";
          break;
      }
      const getSelectedVisitTypeIndex = this.mapVisitsData.scheduleVisitType.findIndex(obj => obj.name === getVisitType);
      const self = this;
      const getvisitsDateSlots = JSON.parse(JSON.stringify(this.mapVisitsData.dateTotalValues));
      const uniqueVisitDatesSlots = [];
      getvisitsDateSlots.push({
        dateValue: self.appointmentDetails.startTime,
        index: this.mapVisitsData.dateTotalValues.length - 1,
        selected: false
      });
      for (let m = 0; m < getvisitsDateSlots.length; m++) {
        if (uniqueVisitDatesSlots.length === 0) {
          uniqueVisitDatesSlots.push({
            dateValue: getvisitsDateSlots[m].dateValue,
            index: 0,
            selected: false
          });
        } else {
          const getDuplicateCheckCount = uniqueVisitDatesSlots.findIndex(v => {
            return new Date(v.dateValue).toLocaleDateString() === new Date(getvisitsDateSlots[m].dateValue).toLocaleDateString();
          });
          if (getDuplicateCheckCount === -1) {
            uniqueVisitDatesSlots.push({
              dateValue: getvisitsDateSlots[m].dateValue,
              index: uniqueVisitDatesSlots.length + 1,
              selected: false
            });
          }
        }
      }
      this.mapVisitsData.dateTotalValues = uniqueVisitDatesSlots;
      const getSelectedDateVisitTypeIndex = this.mapVisitsData.dateTotalValues.findIndex(dateObj => {
        return new Date(dateObj.dateValue).toLocaleDateString() === new Date(self.siteTeamSelectedTaskDetails.startTime).toLocaleDateString();
      });
      const getSavedDateFormatVisitStringValue = new Date(self.siteTeamSelectedTaskDetails.startTime).toLocaleDateString().split("/");
      const saveTimeObj = {
        appointmentSlotId: getAppointmentDetails[0].piAvailabilitySlot,
        availabilityId: getAppointmentDetails[0].piAvailabilityId,
        currentDate: getAppointmentDetails[0].startTime,
        dateString: getSavedDateFormatVisitStringValue[2] + "-" + getSavedDateFormatVisitStringValue[0] + "-" + getSavedDateFormatVisitStringValue[1],
        dateValue: getAppointmentDetails[0].startTime,
        extendWindowSlot: this.visitConfiguredDetails.telehealthVisitDTO.extendAvailability,
        selected: null,
        siteId: getAppointmentDetails[0].siteId,
        slotDate: getAppointmentDetails[0].startTime,
        slotEndTime: getAppointmentDetails[0].endTime,
        slotStartTime: getAppointmentDetails[0].startTime,
        timeZone: this.getLocalOffset()
      };
      this.mapVisitsData.timeTotalValues.push(saveTimeObj);
      this.mapVisitsData.scheduleVisitType[getSelectedVisitTypeIndex].selected = true;
      this.mapVisitsData.dateTotalValues[getSelectedDateVisitTypeIndex].selected = null;
      const selectedDateTimeLists = this.mapVisitsData.timeTotalValues.filter(dateTimeObj => {
        return new Date(dateTimeObj.dateValue).toLocaleDateString() === new Date(getAppointmentDetails[0].startTime).toLocaleDateString();
      });
      this.mapVisitsData.selectedDateTimeLists = selectedDateTimeLists;
      this.$refs.VisitsListsHomePhonecallDataViewModal.hide();
      this.showScheduleVisit = true;
    },
    checkforRescheduleFlag(dataObj) {
      let rescheduleFlag = false;
      if (dataObj.visitType != this.appointmentDetails.visitType) {
        rescheduleFlag = true;
      } else if (dataObj.piAvailabilitySlot != this.appointmentDetails.piAvailabilitySlot) {
        rescheduleFlag = true;
      } else if (dataObj.piAvailabilityId != this.appointmentDetails.piAvailabilityId) {
        rescheduleFlag = true;
      }
      return rescheduleFlag;
    },
    getStudyDetails() {
      this.$api
        .getStudyDataFact(this.$route.params.studyId)
        .then(
          response => {
            if (response.body) {
              this.siteDetailsInfo = response.body.sitesInfo.filter(data => data.id === this.participantInfo.siteId)[0];
            }
          },
          error => {
            const err = error.body && error.body.message ? error.body.message : "Error while getting the study details";
            this.$toastr.error(err);
          }
        )
        .catch(error => {
          if (error && (error.message || error.body.message)) {
            this.$toastr.error(error.message || error.body.message);
          } else {
            this.$toastr.error("Unable to fetch the study details");
          }
        });
    },
    getLocalTimeZone() {
      return new window.Intl.DateTimeFormat().resolvedOptions().timeZone;
    },
    cancelVisitDataEvent(data) {
      this.$api.deleteVisitAppointmentFact(this.$route.params.studyId, this.participantInfo.siteId, this.siteTeamSelectedTaskDetails.id, this.siteTeamSelectedTaskDetails.threadID, data).then(
        response => {
          if (response.body) {
            this.$toastr.success("Visit Appointment cancelled successfully");
            this.showScheduleVisit = false;
            this.getAppointments();
          }
        },
        err => {
          this.showScheduleVisit = false;
          this.$toastr.error(err.body.message);
        }
      );
    },
    isVisitConfiguredInStudy() {
      this.$api.getAvailabilityBtnVisibility(this.studyId).then(
        response => {
          if (response.body == true) {
            this.isVisitsConfiguredInStudy = true;
          } else {
            this.isVisitsConfiguredInStudy = false;
          }
        },
        err => {
          this.$toastr.error(err.body.message);
        }
      );
    }
  }
};
</script>

<style scoped lang="scss">
.appointments {
  font-family: Lato-Regular;
  border-radius: 4px;
  border: solid 1px #e4e8eb;
  background-color: #ffffff;
  color: #4a4a4a;
  width: 100%;

  & .last-updated {
    font-size: 12px;
  }

  & .search-field {
    border: 1px solid #e4e8eb !important;
    height: 38px;
  }

  /* Bootstrap 4 text input with search icon */

  .has-search .form-control {
    padding-left: 2.375rem;
  }

  .has-search .form-control-feedback {
    position: absolute;
    z-index: 2;
    display: block;
    width: 2.375rem;
    height: 2.375rem;
    line-height: 2.375rem;
    text-align: center;
    pointer-events: none;
    color: #aaa;
  }

  .scroll-up {
    font-size: 12px;
    font-weight: bold;
    background-color: #f9f9fb;
    color: #b0bac9;
    padding: 8px 15px;
    border-top: 1px solid #e4e8eb;
    border-bottom: 1px solid #e4e8eb;
  }

  .paddings {
    padding: 20px;
  }

  .appointment-details {
    border-bottom: 1px solid #e4e8eb;
    padding: 15px 15px;
    position: relative;
  }
  fieldset .appointment-details:last-of-type {
    padding-bottom: 30px;
  }

  .appointment-details.unscheduled .appointment-name {
    color: #f0ad4e;
  }

  .status-icon {
    min-width: 4.1%;
  }

  .complete .status-icon {
    background: url("/static/img/telehealth/Telehealth_status_complete.png") no-repeat center center;
    min-height: 15px;
    width: 15px;
  }

  .cancelled .status-icon {
    background: url("/static/img/telehealth/Telehealth_status_canceled.png") no-repeat center center;
    min-height: 15px;
    width: 15px;
  }

  .missed .status-icon {
    background: url("/static/img/telehealth/Telehealth_status_missed.png") no-repeat center center;
    min-height: 15px;
    width: 15px;
  }

  .notstarted .status-icon.call-in-progress,
  .inprogress .status-icon.call-in-progress,
  .initiated .status-icon.call-in-progress {
    background: url("/static/img/telehealth/call-in-progress.png") no-repeat center;
    min-height: 5vh;
    width: 4%;
  }

  //Visit Type Icon CSS
  .visit-type-icon {
    position: absolute;
    min-width: 4%;
    top: 19px;
  }

  //---------Telehealth Visit type--------
  .telehealth-visit {
    .visit-type-icon {
      top: 17px;
    }
  }
  .notstarted.telehealth-visit .visit-type-icon,
  .inprogress.telehealth-visit .visit-type-icon,
  .initiated.telehealth-visit .visit-type-icon {
    background: url("/static/img/telehealth/telehealth_comingUp.png") no-repeat center;
    min-height: 25px;
    min-width: 4.1%;
  }

  .complete.telehealth-visit .visit-type-icon {
    background: url("/static/img/telehealth/telehealth_complete.png") no-repeat center;
    min-height: 25px;
    min-width: 4.1%;
  }

  .missed.telehealth-visit .visit-type-icon,
  .cancelled.telehealth-visit .visit-type-icon {
    background: url("/static/img/telehealth/telehealth_missed.png") no-repeat center;
    min-height: 25px;
    min-width: 4.1%;
  }
  //---------Telehealth Visit type Ends--------

  //---------Inperson Visit type--------
  .notstarted.in-person-visit .visit-type-icon,
  .inprogress.in-person-visit .visit-type-icon,
  .initiated.in-person-visit .visit-type-icon {
    background: url("/static/img/telehealth/InPerson_comingUp.png") no-repeat center;
    width: 21px;
    min-height: 21px;
  }

  .complete.in-person-visit .visit-type-icon {
    background: url("/static/img/telehealth/InPerson_complete.png") no-repeat center;
    width: 21px;
    min-height: 21px;
  }

  .missed.in-person-visit .visit-type-icon,
  .cancelled.in-person-visit .visit-type-icon {
    background: url("/static/img/telehealth/InPerson_missed.png") no-repeat center;
    width: 21px;
    min-height: 21px;
  }

  .notstarted.in-person-visit .visit-type-icon.call-time-passed {
    background: url("/static/img/telehealth/InPerson_warning.png") no-repeat center;
    width: 21px;
    min-height: 21px;
  }

  .inperson-status-dropdown {
    position: relative;
    select {
      background-image: none;
      border-radius: 3px;
      box-shadow: inset 0 1px 2px 0 #e4e8eb;
      border: solid 1px #e4e8eb;
      padding: 0.5em;
      padding-right: 1.7em;
      position: absolute;
      right: 11%;
      top: -8px;
      width: 105px;
    }
    &:after {
      content: "\F107";
      font: normal normal normal 20px/1 FontAwesome;
      color: #1e8fe1;
      right: 7px;
      top: 0;
      height: 34px;
      padding: 0px 0px 0px 1px;
      position: relative;
      pointer-events: none;
    }
  }
  //---------Inperson Visit type Ends--------

  //---------Home Visit type--------
  .notstarted.homevisit-visit .visit-type-icon,
  .inprogress.homevisit-visit .visit-type-icon,
  .initiated.homevisit-visit .visit-type-icon {
    background: url("/static/img/telehealth/homeVisit_comingUp.svg") no-repeat center;
    width: 21px;
    min-height: 21px;
  }

  .complete.homevisit-visit .visit-type-icon {
    background: url("/static/img/telehealth/homeVisit_complete.svg") no-repeat center;
    width: 21px;
    min-height: 21px;
  }

  .missed.homevisit-visit .visit-type-icon,
  .cancelled.homevisit-visit .visit-type-icon {
    background: url("/static/img/telehealth/homeVisit_missed.svg") no-repeat center;
    width: 21px;
    min-height: 21px;
  }

  .notstarted.homevisit-visit .visit-type-icon.call-time-passed {
    background: url("/static/img/telehealth/homeVisit_warning.svg") no-repeat center;
    width: 21px;
    min-height: 21px;
  }
  //---------Home Visit type Ends--------

  //---------Phone Call Visit type--------
  .notstarted.phonecall-visit .visit-type-icon,
  .inprogress.phonecall-visit .visit-type-icon,
  .initiated.phonecall-visit .visit-type-icon {
    background: url("/static/img/telehealth/phoneCall_comingUp.svg") no-repeat center;
    width: 21px;
    min-height: 21px;
  }

  .complete.phonecall-visit .visit-type-icon {
    background: url("/static/img/telehealth/phoneCall_complete.svg") no-repeat center;
    width: 21px;
    min-height: 21px;
  }

  .missed.phonecall-visit .visit-type-icon,
  .cancelled.phonecall-visit .visit-type-icon {
    background: url("/static/img/telehealth/phoneCall_missed.svg") no-repeat center;
    width: 21px;
    min-height: 21px;
  }

  .notstarted.phonecall-visit .visit-type-icon.call-time-passed {
    background: url("/static/img/telehealth/phoneCall_warning.svg") no-repeat center;
    width: 21px;
    min-height: 21px;
  }
  //---------Phone Call Visit type Ends--------

  .complete .time {
    color: #b0bac9;
  }

  fieldset {
    border: 0;
    border-top: 1px solid #f16559;
  }

  .list-header {
    border-bottom: solid 1px #e4e8eb;
  }
  .appointment-lists {
    z-index: 99;
    //position: fixed;
    //width: calc(100% - 281px);
    height: calc(100vh - 197px);
    background-color: #fff !important;
    //-webkit-transition: all 0.5s ease;
    //transition: all 0.5s ease;
    border-right: 1px solid #e3e8eb;
    /* border-left: 1px solid #e3e8eb; */
    overflow-y: auto;
  }

  /*  .appointment-lists.resize-width {
    // width: 52%;
  } */

  .appointment-lists fieldset:first-child {
    margin-top: 10px;
  }

  .date-legend {
    border-radius: 3px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px #e4e8eb;
    background-color: #ffffff;
    padding: 1px 5px;
    font-size: 13px;
    font-weight: bold;
    color: #f16559;
    width: auto;
    margin-left: 25px;
    position: relative;
    top: -13px;
  }

  .join-call {
    background-color: #2ecd71;
    height: 34px;
    padding: 0.375rem 1.74rem;
    font-size: inherit;
  }

  .calendar-header {
    border-bottom: 1px solid #e4e8eb;
  }
  .availability-btn {
    padding: 0.49rem 0.97rem;
    font-size: 0.75rem;
    font-weight: bold;
    color: #1e8fe1;
    border-color: #1e8fe1;
  }
  .availability-btn:hover {
    background-color: #1e8fe1;
    color: #fff;
  }
  .user-definied-pID {
    color: #4a4a4a;
  }
  .new-video-call-btn {
    font-size: 14px;
    padding: 0.354rem 0.75rem;
  }
  /* .weekly-navigation {
    border-bottom: 1px solid #e4e8eb;
    padding: 10px 10px;
    font-weight: bold;
  } */
  .weekly-navigation .fa {
    color: #007bff;
    cursor: pointer;
  }
  .response-msg {
    height: -moz-calc(100vh - 198px);
    height: -webkit-calc(100vh - 198px);
    height: calc(100vh - 198px);
  }
}
.btn-health {
  background-color: #508ee1 !important;
  color: #fff !important;
  cursor: pointer;
  font-family: Roboto-Bold;
  font-size: 12px !important;
}
.arrowColor {
  color: #1e8fe1;
  cursor: pointer;
}
.appointment-container {
  background-color: #ffffff;
}
.btnGroupAlignment {
  position: relative;
  bottom: 10px;
}
.visitNameText {
  cursor: pointer;
  color: #1e8fe1;
}
.visitNameText:hover {
  cursor: pointer;
  color: #1e8fe1;
  text-decoration: underline;
}
.close-icon {
  cursor: pointer;
  float: right;
  position: relative;
  left: 17px;
}
.subHeading {
  font-size: 12px;
  font-weight: bold;
  color: #b0bac9;
}
.rowDiv {
  background-color: #eaf0f4;
}
.evaluateModalPhnoField {
  color: rgba(0, 0, 0, 0.5);
  font-weight: bold;
}
.evaluateAddressField {
  color: #4a4a4a;
  font-weight: bold;
}
.cancelText {
  color: #666669;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}
.activityNameLayout {
  position: relative;
  top: 0.6rem;
}
</style>
